export default __webpack_public_path__ + "static/media/documents.47f01bcf.svg";